import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Handle menu open/close
  useEffect(() => {
    // Add or remove the menu-open class to the body element
    if (menuOpen) {
      document.body.classList.add('menu-open');
      // Prevent scrolling when menu is open
      document.body.style.overflow = 'hidden';
    } else {
      document.body.classList.remove('menu-open');
      // Restore scrolling
      document.body.style.overflow = '';
    }

    // Cleanup - ensure class is removed when component unmounts
    return () => {
      document.body.classList.remove('menu-open');
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  // Handle scroll events
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Call once on mount to set initial state
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Close menu when ESC key is pressed
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape' && menuOpen) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('keydown', handleEscKey);
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [menuOpen]);

  // Close menu when route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Check if link is active
  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className={scrolled ? 'header-scrolled' : ''}>
      <div className="container">
        <Link to="/" className="site-title">
          <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="20" 
              height="20" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
              <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
            </svg>
            RealSoft Newsletter
          </span>
        </Link>
        
        <button 
          className="mobile-menu-button" 
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span className={menuOpen ? 'bar1 active' : 'bar1'}></span>
          <span className={menuOpen ? 'bar2 active' : 'bar2'}></span>
          <span className={menuOpen ? 'bar3 active' : 'bar3'}></span>
        </button>
        
        <nav className={menuOpen ? 'nav-open' : ''}>
          <ul className="nav-list">
            <li>
              <Link 
                to="/" 
                onClick={() => setMenuOpen(false)}
                className={isActive('/') ? 'active-link' : ''}
              >
                Home
              </Link>
            </li>
            <li>
              <Link 
                to="/archive" 
                onClick={() => setMenuOpen(false)}
                className={isActive('/archive') ? 'active-link' : ''}
              >
                Archive
              </Link>
            </li>
            <li>
              <Link 
                to="/about" 
                onClick={() => setMenuOpen(false)}
                className={isActive('/about') ? 'active-link' : ''}
              >
                About
              </Link>
            </li>
            <li>
              <Link 
                to="/submit" 
                onClick={() => setMenuOpen(false)}
                className={isActive('/submit') ? 'active-link' : ''}
              >
                Submit Article
              </Link>
            </li>
            <li>
              <Link 
                to="/subscribe" 
                className={`subscribe-button ${isActive('/subscribe') ? 'active-link' : ''}`}
                onClick={() => setMenuOpen(false)}
              >
                Subscribe
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header; 